import { render, staticRenderFns } from "./student_manager.vue?vue&type=template&id=1d973708&scoped=true"
import script from "./student_manager.vue?vue&type=script&lang=js"
export * from "./student_manager.vue?vue&type=script&lang=js"
import style0 from "./student_manager.vue?vue&type=style&index=0&id=1d973708&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d973708",
  null
  
)

export default component.exports